/**
 * Loads .env before any other project import.
 * This file ONLY imports from node/npm, never from local files.
 *
 * Only loads .env in development mode. In test/production, environment
 * variables must be set externally (process.env, container, CI, etc.).
 */
import { existsSync } from 'fs'
import { join, dirname } from 'path'
import { config } from 'dotenv'

const nodeEnv = process.env['NODE_ENV']

// Only load .env in development (or when NODE_ENV is not set, which defaults to development)
if (!nodeEnv || nodeEnv === 'development') {
  let dir = process.cwd()

  for (let i = 0; i < 3; i++) {
    const envPath = join(dir, '.env')
    if (existsSync(envPath)) {
      config({ path: envPath, quiet: true })
      break
    }
    const parent = dirname(dir)
    if (parent === dir) break
    dir = parent
  }
}
